/**
 * El whiteboard de Zoom Video SDK lanza rechazos sin capturar cuando el
 * guardado/comentarios en la nube no aplica a la sesión:
 * - presentador: "get confId or mmrToken failed"
 * - espectador: "premature EOF" (decode del canal de comentarios)
 *
 * La pizarra colaborativa sigue funcionando; solo falla esa capa opcional.
 * Marcamos el evento como manejado para que no dispare el overlay de
 * webpack-dev-server ni ensucie la consola en cada apertura.
 */

const ZOOM_WB_MARKERS = [
    'web_client_whiteboard',
    'get confId or mmrToken failed',
    'premature EOF',
    'DataCloneError',
    'could not be cloned',
    'DedicatedWorkerGlobalScope',
];

const textFrom = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (value instanceof Error) {
        return `${value.name || ''} ${value.message || ''} ${value.stack || ''}`;
    }
    try {
        return `${value.name || ''} ${value.message || ''} ${String(value)}`;
    } catch {
        return '';
    }
};

export const isZoomWhiteboardNoise = (value) => {
    const text = textFrom(value);
    return ZOOM_WB_MARKERS.some((marker) => text.includes(marker));
};

let installed = false;

export const suppressZoomWhiteboardNoise = () => {
    if (installed || typeof window === 'undefined') return;
    installed = true;

    // capture: true para correr antes del overlay de webpack-dev-server
    // (ese escucha en bubble) y poder cortar el evento.
    window.addEventListener('unhandledrejection', (event) => {
        if (!isZoomWhiteboardNoise(event.reason)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
    }, true);

    window.addEventListener('error', (event) => {
        const payload = event.error || event.message;
        if (!isZoomWhiteboardNoise(payload)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
    }, true);
};
